<template>
  <section class="policy-form flex-1">
    <lazy-dom>
      <el-form
        ref="form"
        :rules="formRules"
        :disabled="showBuyable"
        :model="formData">
        <div
          v-if="isCancel"
          class="box">
          <h3></h3>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Cancellation Effective Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                :prop="checkRefer===1?'':'pcy_expry_dt'">
                <v-date-picker
                  v-model="formData.pcy_expry_dt"
                />
              </el-form-item>

            </div>
          </div>
        </div>
        <div class="box">
          <h2>Policy Detail</h2>
          <div class="flex-sb travel-group">
            <div class="form-item form-half">
              <span>Plan Type</span>
              <el-form-item
                prop="plan_type">
                <v-select
                  v-model="formData.plan_type"
                  disabled
                  :list="localAllOptions.plan_type" />
              </el-form-item>
            </div>

          </div>
          <div>
            <div class="form-item form-half travel-group">
              <span>Class Type</span>
              <el-form-item
                prop="class_type">
                <v-radio-group
                  v-model="formData.class_type"
                  disabled
                  :list="class_type_list" />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="!isSinglePlan"
            class="form-item form-half">
            <span>Coverage</span>
            <v-input
              v-model="formData.destination"
              keyNonChinese
              uppercase
              :disabled="checkDisabled('destination')||isEasyGo"/>
          </div>
          <div
            v-else
            class="form-item form-half">
            <span>Main Destination (Must be HK Departures)</span>
            <el-form-item
              prop="destination_id">
              <v-select
                v-model="formData.destination_id"
                :list="destiationList"
                :multiple-limit="10"
                :multiple="true"
                :disabled="checkDisabled('destination_id')"/>
            </el-form-item>
          </div>
          <!--          <div class="flex-sb">-->
          <!--            <div class="form-item form-half">-->
          <!--              <span>Effective Date</span>-->
          <!--              <el-form-item-->
          <!--                prop="pcy_cmnt_dt">-->
          <!--                <v-date-picker-->
          <!--                  v-model="formData.pcy_cmnt_dt" />-->
          <!--              </el-form-item>-->
          <!--            </div>-->

          <!--          </div>-->
          <template  v-if="!isCancel">
            <template v-if="formData.plan_type==2">
              <div
                class="flex-sb">
                <div class="form-item form-half">
                  <span>{{isEndorsement? 'Endorsement Effective Date': 'Expected  Effective Date' }}</span>
                  <el-form-item
                    ref="pcy_cmnt_dt"
                    :prop="checkRefer===1?'':'pcy_cmnt_dt'">
                    <v-date-picker
                      v-model="formData.pcy_cmnt_dt"
                    />
                  </el-form-item>
                </div>
              </div>
              <div
                class="form-item form-half">
                <span>Expected Expiry Date</span>
                <el-form-item
                  prop="pcy_expry_dt">
                  <v-date-picker
                    v-model="formData.pcy_expry_dt"
                    :disabled="formData.plan_type==2 || (isEndorsement&&formData.plan_type==2)" />
                </el-form-item>
              </div>
            </template>
            <template v-if="formData.plan_type==4">
              <div class="form-item form-half">
                <span>{{isEndorsement? 'Endorsement Effective Date': 'Expected  Effective Date' }}</span>
                <el-form-item
                  :prop="checkRefer===1?'':'pcy_cmnt_dt'">
                  <v-date-picker
                    v-model="formData.oneDayDate"
                    type="date"
                    :picker-options="oneDayPickerOptions"
                    @change="handleDate">
                  </v-date-picker>
                </el-form-item>
              </div>
            </template>
            <template v-if="formData.plan_type!=4&&formData.plan_type!=2">
              <div class="form-item form-half">
                <span>{{isEndorsement? 'Endorsement Effective Date': 'Expected  Effective Date' }}</span>
                <el-form-item
                  :prop="checkRefer===1?'':'date'">
                  <v-date-picker
                    v-model="formData.date"
                    type="daterange"
                    range-separator="-"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :clearable="false"
                    :picker-options="pickerOptions"
                    @change="handleDate">
                  </v-date-picker>
                </el-form-item>
              </div>
            </template>
          </template>
          <!--        <span class="title">Number of Traveller</span>-->
          <!--          <div-->
          <!--            v-if="formData.class_type!=3&&!hasChild&&!isEasyGo&&!(isSinglePlan&&isAnnual&&isIndividual)"-->
          <!--            class="flex-sb">-->
          <!--            <div class="form-item form-half">-->
          <!--              <span>No. of Traveller(s)</span>-->
          <!--              <el-form-item-->
          <!--                prop="no_of_traveler">-->
          <!--                <v-select-->
          <!--                  v-model="formData.no_of_traveler"-->
          <!--                  disabled-->
          <!--                  :list="localAllOptions.traveler_num" />-->
          <!--              </el-form-item>-->
          <!--            </div>-->

          <!--          </div>-->
          <template  >
            <div
              class="flex-sb">
              <div class="form-item form-half">
                <span>Number of Senior</span>
                <el-form-item
                  prop="no_of_adult">
                  <v-input
                    v-model="formData.no_of_senior"
                    disabled
                  />
                </el-form-item>
              </div>
            </div>
            <div
              class="flex-sb">
              <div class="form-item form-half">
                <span>Number of Adult</span>
                <!--                :disabled="isCancel||hasChild||isEasyGo"-->
                <el-form-item
                  prop="no_of_adult">
                  <v-input
                    v-model="formData.no_of_adult"
                    disabled
                  />
                </el-form-item>
              </div>
            </div>
            <div
              class="form-item form-half"
            >
              <span>Number of Child </span>
              <el-form-item
                prop="no_of_child">
                <v-select
                  v-model="formData.no_of_child"
                  disabled
                  :list="localAllOptions.child_num" />
              </el-form-item>
            </div>
          </template>
        </div>
        <div
          v-if="isRefer&&insuredItems.length>0 && formData.plan_type != 4"
          class="box">
          <h3>Insured Items</h3>
          <div class="form-item option_checkout">
            <v-checkbox-group
              v-model="formData.benefits"
              :isColumn="false"
              :list="insuredItems" />
          </div>
        </div>
        <div
          v-if="benefitList.length>0&&!isRefer && formData.plan_type != 4"
          class="box">
          <!--          <h2>Insured Items</h2>-->
          <div
            class="form-item form-half">
            <span>Insured Items</span>
            <el-form-item
            >
              <v-checkbox-group
                v-model="formData.benefits"
                :list="benefitList"
                :isColumn="false"
                @change="handlerExtra"
              />
            </el-form-item>
          </div>
        </div>
        <!--        <div class="box">-->
        <!--          <h2>Policyholder Details</h2>-->
        <!--          <travel-policy-holder-form-->
        <!--            ref="travel-policy-holder-form"-->
        <!--            :formDataLock="formDataLock"-->
        <!--            :form="formData"-->
        <!--            :disabled="isCancel"-->
        <!--            :isRequired="isRequired"-->
        <!--            :checkRefer="checkRefer"-->
        <!--            @getFormData="getSubFormData"-->
        <!--            @one-travel="handlerTravelStatus"-->
        <!--            @change-travel="handlerPolicyTravelInfo"-->
        <!--            @confirm="getConfirmChangeResult" />-->
        <!--        </div>-->
        <div class="box">
          <h3>Policyholder Details</h3>
          <div class="form-item form-half">
            <span>Title</span>
            <el-form-item prop="isrd_title">
              <v-select
                v-model="formData.isrd_title"
                :disabled="isCancel||checkDisabled('isrd_title')"
                :list="titleOptions"
                @change="handlerSamePolicyInfo" />
            </el-form-item>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Last Name</span>
              <el-form-item prop="isrd_lst_nm">
                <v-input
                  v-model="formData.isrd_lst_nm"
                  uppercase
                  :disabled="isCancel||checkDisabled('isrd_lst_nm')"
                  @change="handlerSamePolicyInfo"/>
              </el-form-item>
            </div>

          </div>
          <div class="form-item form-half">
            <span>First Name</span>
            <el-form-item prop="isrd_fst_nm">
              <v-input
                v-model="formData.isrd_fst_nm"
                uppercase
                :disabled="isCancel||checkDisabled('isrd_fst_nm')"
                @change="handlerSamePolicyInfo"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Date of Birth</span>
            <el-form-item prop="isrd_dob">
              <v-birth-day
                v-model="formData.isrd_dob"
                :disabled="isCancel||checkDisabled('isrd_dob')"
                @change="handlerSamePolicyInfo"
              />
            </el-form-item>
          </div>
          <div class="form-half">
            <div class="form-item">
              <span>{{formData.id_type==2?'Passport':'HKID'}} Number</span>
              <el-form-item
                ref="id_type"
              >
                <v-radio-group
                  v-model="formData.id_type"
                  :disabled="isCancel||checkDisabled('id_type')"
                  :list="personalIdTypOptions"
                  @change="handlerSamePolicyInfo"
                />
              </el-form-item>
              <el-form-item
                v-if="formData.id_type==1"
                prop="id_no"
              >
                <v-input
                  v-model="formData.id_no"
                  uppercase
                  :disabled="isCancel||checkDisabled('id_no')"
                  placeholder="A123456(3), please input A1234563"
                  class="mg-t-5"
                  @change="handlerSamePolicyInfo" />
              </el-form-item>
              <template v-if="formData.id_type==2">
                <div class="form-item mg-t-5">
                  <el-form-item
                    prop="id_no">
                    <v-input
                      v-model="formData.id_no"
                      uppercase
                      :disabled="checkDisabled('id_no')"
                      class="mg-t-5"
                      @change="handlerSamePolicyInfo" />
                  </el-form-item>
                </div>
                <div class="form-item mg-t-5">
                  <span>Nationality</span>
                  <el-form-item
                    ref="id_nationality_seq"
                    prop="id_nationality_seq">
                    <v-select
                      v-model="formData.id_nationality_seq"
                      :disabled="checkDisabled('id_nationality_seq')"
                      :list="nationalityList" />
                  </el-form-item>
                </div>
              </template>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Mobile Number</span>
            <el-form-item prop="mobile_no">
              <v-input
                v-model="formData.mobile_no"
                :disabled="isCancel||checkDisabled('mobile_no')"
                type="number"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Email</span>
            <el-form-item
              ref="email"
              prop="email"
              :rules="rules.email">
              <v-input
                v-model="formData.email"
                :disabled="isCancel||checkDisabled('email')"/>
            </el-form-item>
          </div>
          <div
            v-if="isAnual"
            class="form-item form-half">
            <span>Occupation</span>
            <el-form-item prop="occ_id">
              <v-select
                v-model="formData.occ_id"
                :disabled="isCancel||checkDisabled('email')"
                :list="allOptions23.occupation"/>
            </el-form-item>
          </div>
          <div
            v-if="!isAnual"
            class="form-item">
            <span>Policyholder is one of the traveller?</span>
            <el-form-item prop="hldr_is_traveler_ind">
              <v-radio-group
                v-model="formData.hldr_is_traveler_ind"
                :border="true"
                :disabled="isCancel"
                :list="yesNoOptions"
                @change="handlerSamePolicyInfo" />
            </el-form-item>
          </div>
          <template v-if="!isEasyGo">
            <span class="title">Correspondence Address</span>
            <address-form
              ref="address-form"
              :formType="1"
              :formDataLock="formDataLock"
              :form="formData"
              :disabled="isCancel||showBuyable"
              :not-valid="checkRefer===1?true:false"
              @getFormData="getAddressForm" />
          </template>
        </div>

        <div class="box">
          <h2>Traveller Details</h2>
          <div
            v-for="(item,index) in formData.nm_traveler_list"
            :key="index"
            class="travel-card ">
            <h3 class="travel-title">Traveller {{index+1}}</h3>
            <div class="flex-sb">
              <div class=" form-half">
                <div class="form-item">
                  <Span>Title</Span>
                  <el-form-item
                    :ref="'nm_traveler_list.'+index+'.title'"
                    :prop="'nm_traveler_list.'+index+'.title'"
                    :rules="!isRules?[]:rules.title"
                  >
                    <v-select
                      v-model="item.title"
                      :disabled="isCancel||is_traveler_ind&&index==0"
                      :list="titleOptions" />
                  </el-form-item>
                </div>
                <div >
                  <div class="form-item ">
                    <span>Last Name</span>
                    <el-form-item
                      :ref="'nm_traveler_list.'+index+'.lst_nm'"
                      :prop="'nm_traveler_list.'+index+'.lst_nm'"
                      :rules="!isRules?[]:rules.lst_nm">
                      <v-input
                        v-model="item.lst_nm"
                        uppercase
                        :disabled="isCancel||is_traveler_ind&&index==0 ||checkDisabled('lst_nm')"/>
                    </el-form-item>
                  </div>
                  <div class="form-item ">
                    <span>First Name</span>
                    <el-form-item
                      :ref="'nm_traveler_list.'+index+'.fst_nm'"
                      :prop="'nm_traveler_list.'+index+'.fst_nm'"
                      :rules="!isRules?[]:rules.fst_nm">
                      <v-input
                        v-model="item.fst_nm"
                        uppercase
                        :disabled="isCancel||is_traveler_ind&&index==0 || checkDisabled('fst_nm')"/>
                    </el-form-item>
                  </div>
                </div>

              </div>
              <div class="form-half">
                <div class="form-item">
                  <span>{{item.id_type==2?'Passport':'HKID'}} Number</span>
                  <el-form-item
                    ref="id_type"
                  >
                    <v-radio-group
                      v-model="item.id_type"
                      :disabled="isCancel||is_traveler_ind&&index==0"
                      :list="personalIdTypOptions" />
                  </el-form-item>
                  <el-form-item
                    v-if="item.id_type==1"
                    :ref="'nm_traveler_list.'+index+'.id_no'"
                    :prop="'nm_traveler_list.'+index+'.id_no'"
                    :rules="!isRules?[]:rules.id_no"
                  >
                    <v-input
                      v-model="item.id_no"
                      uppercase
                      placeholder="A123456(3), please input A1234563"
                      :disabled="isCancel||is_traveler_ind&&index==0"
                      class="mg-t-5" />
                  </el-form-item>
                  <template v-else>
                    <div class="form-item">
                      <el-form-item
                        :prop="'nm_traveler_list.'+index+'.id_no'"
                        :rules="!isRules?[]:rules.id_no"
                      >
                        <v-input
                          v-model="item.id_no"
                          uppercase
                          :disabled="isCancel||is_traveler_ind&&index==0"
                          class="mg-t-5" />
                      </el-form-item>
                    </div>
                    <div class="form-item">
                      <span>Nationality</span>
                      <el-form-item
                        ref="id_nationality_seq"
                        :prop="'nm_traveler_list.'+index+'.id_nationality_seq'"
                        :rules="!isRules?[]:extraRules.id_nationality_seq"
                      >
                        <v-select
                          v-model="item.id_nationality_seq"
                          :disabled="isCancel||is_traveler_ind&&index==0"
                          :list="nationalityList" />
                      </el-form-item>
                    </div>
                  </template>
                </div>
                <div class="form-item">
                  <span>Date of Birth</span>
                  <el-form-item
                    :ref="'nm_traveler_list.'+index+'.dob'"
                    :prop="'nm_traveler_list.'+index+'.dob'"
                    :rules="!isRules?[]:rules.dob"
                  >
                    <v-birth-day
                      v-model="item.dob"
                      :disabled="isCancel||is_traveler_ind&&index==0"/>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Relationship</span>
                  <el-form-item
                    :ref="'nm_traveler_list.'+index+'.rel'"
                    :prop="'nm_traveler_list.'+index+'.rel'"
                    :rules="!isRules?[]:rules.rel"
                  >
                    <!--                    <v-select-->
                    <!--                      v-model="item.rel"-->
                    <!--                      :disabled="policyOneTravel&&index==0||isCancel"-->
                    <!--                      :list="policyOneTravel&&index==0||isCancel?localAllOptions.relation:relList"/>      -->
                    <v-select
                      v-model="item.rel"
                      :disabled="is_traveler_ind&&index==0||isCancel"
                      :list="relationData2(index)"/>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div
              v-if="showGuardian(index,item.rel)"
              class="flex-sb">
              <div class="form-half">
                <p class="travel-title mg-b-8">Parents or Legal Guardian</p>
                <div class="form-item">
                  <span>Name</span>
                  <el-form-item
                    :ref="'nm_traveler_list.'+index+'.guardian_nm'"
                    :prop="'nm_traveler_list.'+index+'.guardian_nm'"
                    :rules="!isRules?[]:rules.guardian_nm"
                  >
                    <v-input
                      v-model="item.guardian_nm"
                      uppercase
                      :disabled="isCancel||is_traveler_ind&&index==0 ||checkDisabled('guardian_nm')"/>

                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Contact Number</span>
                  <el-form-item
                    :ref="'nm_traveler_list.'+index+'.guardian_phone'"
                    :prop="'nm_traveler_list.'+index+'.guardian_phone'"
                    :rules="!isRules?[]:rules.guardian_phone"
                  >
                    <v-input
                      v-model="item.guardian_phone"
                      uppercase
                      :disabled="isCancel||is_traveler_ind&&index==0 ||checkDisabled('guardian_phone')"/>

                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="box travel-box">
          <h2>Upload Document</h2>
          <div
            v-if="editType==3"
            class="flex-sb">
            <div class="form-item form-half">
              <span >Renewal Letter（Insurer）</span>
              <el-form-item
                ref="renewal_letter_insurer_path_id"
                prop="renewal_letter_insurer_path_id">
                <v-upload
                  :card="true"
                  ::disabled="isCancel||showBuyable"
                  :fileData="formData.renewal_letter_insurer"
                  :otherData="{
                    target: 'renewal_letter_insurer',
                    idKey: 'renewal_letter_insurer_path_id',
                    nameKey: 'renewal_letter_insurer_path',
                    type:'renewal_letter_insurer_path'
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
          </div>
          <div class="flex">
            <div class="form-item form-half">
              <span>Policyholder HKID</span>
              <el-form-item prop="id_type_pic_path_id">
                <v-upload
                  :card="true"
                  :disabled="isCancel||showBuyable"
                  :fileData="formData.id_type_pic"
                  :file-list="fileList"
                  :otherData="{
                    target: 'id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path',
                    type:'id_type_pic_path'
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
            <div
              v-for="(item,index) in formData.nm_traveler_list"
              :key="'travel_'+index"
              class="form-item form-half">
              <span v-if="!is_traveler_ind||is_traveler_ind&&index!==0">Traveler {{index+1}}</span>
              <el-form-item
                v-if="!is_traveler_ind||is_traveler_ind&&index!==0"
                :ref="'nm_traveler_list.'+index+'.id_type_pic_path_id'"
                :prop="'nm_traveler_list.'+index+'.id_type_pic_path_id'"
                :rules="!isRules?[]:rules.id_type_pic_path_id">
                <v-upload
                  :disabled="isCancel||showBuyable"
                  :card="true"
                  :file-list="fileList"
                  :fileData="{
                    url: item.id_type_pic_url,
                    client_name: item.client_name,
                    thumb_url: item.id_type_pic_url,
                    type:'traveler_id_type_pic'
                  }"
                  :otherData="{
                    target: 'id_type_pic_url',
                    type: 'traveler_id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path',
                    index
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
          </div>
        <!--        <div class="form-item">-->
        <!--          <span>Additional Documents</span>-->
        <!--          <file-container-->
        <!--            v-for="(item, index) in formData.other_file"-->
        <!--            :key="index"-->
        <!--            :fileData="item"-->
        <!--            :otherData="{-->
        <!--              index,-->
        <!--              type: 'other'-->
        <!--            }" -->
        <!--            :edit="true"-->
        <!--            @delete="handlerDeleteFile"-->
        <!--            @uploadSuccess="handlerUploadSuccess"-->
        <!--          />-->
        <!--          <v-upload-->
        <!--            :otherData="{-->
        <!--              type: 'other',-->
        <!--            }" -->
        <!--            @uploadSuccess="handlerUploadSuccess" />-->
        <!--        </div>-->
        </div>

      </el-form>
    </lazy-dom>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import MixinSame from '@/mixins/same'
import AddressForm from '@/views/components/address-form'

export default {
  name: 'TravelPolicyForm',
  components: {
    AddressForm
    // TravelPolicyHolderForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules,MixinSame],
  props: {
    form: {
      type: Object,
      default: null
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isCheckDate: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    isAdjust: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const check = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { no_of_traveler,no_of_adult,no_of_child,no_of_senior } = this.formData
      let data = Number(no_of_adult)+Number(no_of_child)+Number(no_of_senior)
      if( data>no_of_traveler) {
        callback(new Error('選擇人數不能超出旅遊總人數'))
      }
      callback()
    }
    const checkDate = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { date=[] } = this.formData||{}
      if(date&&date.length<=0) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    const checkBirth = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      let {nm_traveler_list=[],no_of_child,plan_type,class_type,no_of_traveler} = this.formData||{}
      const index = field_arr[1]
      let travleObj = nm_traveler_list[index]||{}
      let {dob='',rel} = travleObj||{}
      let child_index = no_of_child>0?(no_of_traveler - no_of_child):no_of_traveler
      let is_child = child_index<=index //判断从第几个开始是小孩is_child
      if([1,3].includes(plan_type)&&dob&&class_type==1)
      {
        let today = this.today()
        if(this.check18Years(dob,today)&&is_child) {
          callback( new Error('小孩年齡限制在18歲以下' ) )
        }
        if(!this.check18Years(dob,today)&&!is_child) {
          callback( new Error('成人年齡限制在18歲以上' ) )
        }
      }
      if(!dob){
        callback( new Error(this.$t('placeholder.input')) )
      }
      callback()
    }
    const checkSeniorAge = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const { senior_age_list } = this.formData||{}
      if(!senior_age_list[index]){
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    return {
      formDataLock: 0,
      policyOneTravel:true,
      init:false,
      obj: {
        rel:'',
        title:'',
        id_type:1,
        id_no:'',
        dob:'',
        lst_nm:'',
        fst_nm:'',
        id_type_pic_path_id: '',
        id_type_pic_path: '',
        id_type_pic_url: '',
        id_type_pic_thumb_url:'',
        client_name: '',
        guardian_nm:'',
        guardian_phone:'',
        is_child:0
      },
      formData: {
        class_id: '',
        destination: '',
        destination_id:[],
        no_of_traveler: '',
        no_of_senior: '',
        senior_age_list:[],
        plan_type: '',
        pcy_period:'',
        class_type: '',
        pcy_cmnt_dt: '',
        pcy_expry_dt: '',
        no_of_adult: '',
        no_of_child: '',
        // file
        id_type_pic_path: '',
        id_type_pic_path_id: '',
        id_type_pic: {},
        other_file: [],
        nm_traveler_list:[],
        area_of_travel:'',
        occ_id:'',

        isrd_title: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        isrd_dob: '',
        id_type: 1,
        id_no: '',
        mobile_no: '',
        isrd_dob_date: '',
        email: '',
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
        hldr_is_traveler_ind:'',
        benefits: [],
        id_nationality_seq: '',
        date:[],
        oneDayDate:'',
        renewal_letter_insurer_path: '',
        renewal_letter_insurer_path_id: '',
        renewal_letter_insurer: {},
      },
      subForm: {
        'address-form': false,
      },
      addressForm: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      otherData: {},
      extraRules: {
        id_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        pp_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_nationality_seq: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        fst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        lst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        title: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        rel: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        no_of_child:[
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] },
          { validator: check, trigger: ['change', 'blur']},
        ],
        no_of_adult:[
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] },
          { validator: check,trigger: ['change', 'blur']}
        ],
        dob: [
          { validator: checkBirth,trigger: ['change', 'blur']}
        ],
        guardian_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        destination_id: [
          { required: true,message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        date: [
          { validator: checkDate, trigger: ['change', 'blur'] }
        ],
        senior_age:[
          { validator: checkSeniorAge, trigger: ['change', 'blur'] }
        ]
        // id_type_pic_path_id: [
        //   { required: true, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        // ],
        // pcy_cmnt_dt: [
        //   { validator: checkStartDate, trigger: ['change', 'blur'] }
        // ],
        // pcy_expry_dt: [
        //   { validator: checkEndDate, trigger: ['change', 'blur'] }
        // ],
      }
    }
  },
  computed: {
    isAnual(){
      let {plan_type} = this.form||{}
      return plan_type==2
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      if(this.editQuote){
        arr = JSON.parse(JSON.stringify(this[`allOptions${this.formData.class_id}`].benefits))
      }else{
        kyc_benefit.some(item=>{
          // if(item.is_selected==1)
          //   this.formData.benefits.push(item.id)
          if(item.is_show!==0){
            arr.push({name:item.name,id:item.id})
          }
        })
      }
      return arr||[]
    },
    localAllOptions() {
      return this.allOptions23
    },
    insuredItems(){
      let {benefits=[]} = this.allOptions23
      return benefits||[]
    },
    relList(){
      let arr = this.localAllOptions.relation
      arr = arr.filter(item=>{
        return item.id!=1
      })
      return arr
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })


      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
    isRules(){
      return this.checkRefer ===2
    },
    is_traveler_ind(){
      return this.formData.hldr_is_traveler_ind ===1
    },
    isOneTravel(){
      return this.policyOneTravel
    },
    relationData2() {
      return index => {
        let relation = this.localAllOptions.relation || []
        // 一日游的人物关系
        let oneDayRelation = this.localAllOptions.relation_od || []
        // 只有自己
        let oneDayOnlySelf = oneDayRelation.filter(item => item.id == 1)
        // 没有自己
        let {no_of_traveler,class_type,plan_type} = this.formData
        let oneDayExceptSelf = oneDayRelation.filter(item => item.id != 1)
        let oneDayTr = plan_type == 4
        // relation = relation.filter(item => item.type == type)
        let onlySelfData = relation.filter(item => item.id == 1) // 只有自己
        let exceptSelfData = relation.filter(item => item.id != 1) // 沒有自己
        let familyData = exceptSelfData.filter(item => item.id == 2) // 只有配偶
        let childData = exceptSelfData.filter(item => item.id == 3) // 只有子女
        let otherData = exceptSelfData.filter(item=>![1,2].includes(item.id))//小孩选项
        let none_child_data = exceptSelfData.filter(item=>![1,3].includes(item.id))//沒有小孩选项
        let familyType = class_type == 3     //家庭計劃

        let no_of_adult = this.formData.no_of_adult        //成人數量
        let no_of_child = this.formData.no_of_child        //孩童數量
        let no_of_senior = this.formData.no_of_senior        //孩童數量
        // let plan_child = [1,3].includes(plan_type)//單次旅遊保障（單程&來回）
        let child_index = no_of_traveler  - no_of_child
        let senior_index =no_of_traveler - no_of_senior - no_of_child
        let is_child =  index>=child_index
        let is_senior = index>=senior_index
        if(no_of_child>0){
          is_child =  index>=child_index
        }else is_child = false
        let adult_num = no_of_adult + no_of_senior
        if(index==0){
          // 第一名travel
          if(oneDayTr){
            return this.is_traveler_ind? oneDayOnlySelf : oneDayExceptSelf
          }else{
            return this.is_traveler_ind
              ? onlySelfData
              : familyType
                ? familyData
                :is_child?otherData:( is_senior?none_child_data:!is_child?none_child_data:exceptSelfData)
          }
        }else{
          // 第x名travel
          if(oneDayTr){
            return oneDayExceptSelf
          }else{
            // return familyType         // 家庭計劃
            //   ? no_of_adult==2 && index==1
            //     ? familyData          //成人數量為2 並且是第二名traveler 只有配偶
            //     : childData           // 成人不為2 或者 不是第二名 traveler, 只有子女
            //   :is_child?otherData: exceptSelfData        // 個人計劃
            return familyType         // 家庭計劃
              ? adult_num==2 && index==1
                ? familyData          //成人數量為2 並且是第二名traveler 只有配偶
                : childData           // 成人不為2 或者 不是第二名 traveler, 只有子女
              :is_child?otherData: ( is_senior?none_child_data:exceptSelfData)        // 個人計劃
          }
        }
      }
    },
    nationalityList(){
      return this.globalOptions.id_nationality_seq || []
    },
    showGuardian(){
      return (index,id) =>{
        if([1,2,3].includes(id)||id=='')
          return false
        else{
          let { no_of_child,plan_type,no_of_traveler,class_type} = this.formData || {}
          let plan_child = [1,3].includes(plan_type)//單次旅遊保障（單程&來回）
          let child_index = plan_child&&class_type==1?(no_of_traveler - no_of_child):no_of_traveler
          let is_child =  index>=child_index
          if(is_child)
            return true
          return false
        }
      }
    },
    hasChild(){
      let { no_of_child,plan_type} = this.formData || {}
      return [1,3,5].includes(plan_type)&&no_of_child>0
    },
    isSinglePlan(){
      let {plan_type} = this.formData || {}
      return [1,3].includes(plan_type)//單次旅遊保障（單程&來回）
    },
    destiationList(){
      let {area_of_travel} = this.formData||{}
      let {destinations=[] } = this.localAllOptions||{}
      // return destinations.filter(item=>item.type==area_of_travel||item.type==3)
      return destinations.filter(item=>{
        return item.type!=0
      })
    },
    rangeDay() {
      const { plan_type } = this.formData
      return plan_type == 3 ? 7 : 182
    },
    pickerOptions(){
      return{
        onPick: (obj) => {
          this.formData.pcy_cmnt_dt = new Date(obj.minDate).getTime()
          if(obj.maxDate){
            this.formData.pcy_expry_dt = dayjs(obj.maxDate).format('YYYY-MM-DD')
          }
        },
        disabledDate: (time) => {
          let today = dayjs()
          let end = dayjs(time)
          if(this.formData.pcy_cmnt_dt) {
            let start = dayjs(this.formData.pcy_cmnt_dt)
            // 结束日期大于开始日期7天或者小于开始日期就禁用
            const curtime = end.format('YYYY-MM-DD')
            const endDiff = end.diff(start, 'day')

            const mindate = start.subtract(this.rangeDay-1, 'day')

            const isBefore = dayjs(today).isBefore(mindate)

            const diffTime = isBefore ? mindate : today
            let {plan_type} = this.formData||{}
            // start
            if(this.isEndorsement,[1,3].includes(plan_type)){
              return
            }
            return endDiff >= this.rangeDay || end.diff(diffTime, 'day') < 0
          }
          else {
            return end.diff(today, 'day') < 0
          }
        },
      }
    },
    oneDayPickerOptions(){
      return{
        disabledDate: (time) => {
          let now = Date.now()
          let selectTime = time.getTime()
          let diff = (selectTime - now) / (3600 * 1000 * 24)
          return diff < 0 || diff > 45
        },
      }
    },
    isEasyGo(){
      let {plan_type} = this.formData||{}
      return plan_type == 5
    },
    isAnnual(){
      let {plan_type} = this.formData||{}
      return plan_type == 2
    },
    area_of_travel_list(){
      let {area_of_travel=[]} = this.localAllOptions||{}
      if(this.isEasyGo){
        return area_of_travel.filter(item=>item.id==1)
      }
      return area_of_travel
    },
    class_type_list(){
      let {class_type=[]} = this.localAllOptions||{}
      if(this.isEasyGo){
        return class_type.filter(item=>item.id==1)
      }
      return class_type
    },
    isIndividual(){
      let {class_type} = this.formData||{}
      return class_type ==1
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      handler(val) {
        if(val) {
          // 觸發更新就賦值，避免二次更新
          // this.oldFormDataLock = this.formDataLock
          const formValue = JSON.parse(JSON.stringify(val))
          this.formData = Object.assign(
            this.formData,
            formValue
          )
          let {quote_coverage_list,pcy_cmnt_dt,pcy_expry_dt,destination_id=[] } = this.formData||{}
          let des_arr =[]
          if(destination_id&&destination_id.length>0){
            let arr = destination_id.split(',')
            arr.some(item=>{
              des_arr.push(Number(item))
            })
          }
          this.formData.destination_id = des_arr||[]
          this.formData.date = [pcy_cmnt_dt,pcy_expry_dt]
          this.formData.oneDayDate = pcy_cmnt_dt
          let {kyc_benefit=[]} = quote_coverage_list||{}
          kyc_benefit.some(item=>{
            if(item.is_selected==1)
              this.formData.benefits.push(item.id)
          })
          this.formData.benefits= [...new Set( this.formData.benefits)]
          this.handler().handlerAddress(formValue)
          let {class_type, hldr_is_traveler_ind,plan_type} = this.formData || {}
          this.handler().handlerAddress(formValue)
          // this.policyOneTravel = hldr_is_traveler_ind==1
          let {no_of_traveler, nm_traveler_list = [], no_of_adult, no_of_child,no_of_senior} = val || {}
          let travel_no = no_of_traveler
          if (nm_traveler_list.length <= 0) {
            for (var i = 0; i < travel_no; i++) {
              let obj = JSON.parse(JSON.stringify(this.obj))
              this.formData.nm_traveler_list.push(obj)
            }
          } else {
            this.formData.nm_traveler_list = nm_traveler_list
          }
          let plan_child = [1,3,5].includes(plan_type)//單次旅遊保障（單程&來回）
          let child_index = plan_child&&class_type==1?(no_of_traveler - no_of_child):no_of_traveler
          this.formData.nm_traveler_list.filter((item,index)=>{
            if(index>=child_index){
              item.is_child = 1
            }
          })
          if(this.init) return
          // this.policyOneTravel = hldr_is_traveler_ind==1
          if ([2].includes(class_type)) {
            // this.formData.no_of_adult = no_of_adult || 1
            // this.formData.no_of_child = no_of_child || 1
            // this.formData.no_of_senior = no_of_senior || 1
            this.formData.no_of_adult = no_of_adult
            this.formData.no_of_child = no_of_child
            this.formData.no_of_senior = no_of_senior
          }
          if ([1].includes(class_type)) {
            // this.formData.no_of_adult = no_of_adult||1
            //   if(plan_type==1)
            //   {
            //     this.formData.no_of_adult = no_of_adult
            //     this.formData.no_of_child = no_of_child
            //     this.formData.no_of_senior = no_of_senior
            //     travel_no = no_of_adult + no_of_child + no_of_senior
            //   }
            // } else {
            this.formData.no_of_adult = no_of_adult
            this.formData.no_of_child = no_of_child
            this.formData.no_of_senior = no_of_senior
            travel_no = no_of_adult + no_of_child + no_of_senior
          }
          // if([3].includes(class_type))
          //   this.formData.no_of_adult = no_of_traveler

          // if ([4].includes(class_type))
          //   this.formData.no_of_adult = no_of_traveler < 2 ? no_of_traveler : 2
          if (formValue.id_type_pic) {
            const {path, id} = val.id_type_pic
            this.formData.id_type_pic_path = path
            this.formData.id_type_pic_path_id = id
          }
          this.init = true
        }
      }
    },
    'formData.no_of_senior':{
      immediate:true,
      handler(val){
        let {no_of_traveler,class_type,no_of_child,nm_traveler_list,no_of_adult} = this.formData
        if(class_type!=3)
        {
          if(no_of_traveler>val)
            this.formData.no_of_child = Number(no_of_traveler) - Number(val) - Number(no_of_adult)
          else   this.formData.no_of_child =0
        }else{
          let travel_no = Number(val)+no_of_child +no_of_adult
          this.formData.no_of_traveler = travel_no
          if(nm_traveler_list.length<travel_no)
            for (var i= nm_traveler_list.length;i<travel_no;i++){
              let obj = JSON.parse(JSON.stringify(this.obj))
              this.formData.nm_traveler_list.push(obj)
            }
          else {
            this.formData.nm_traveler_list.splice(travel_no,nm_traveler_list.length-travel_no)
          }
        }
      }
    },
    'formData.no_of_adult':{
      immediate:true,
      handler(val){
        let {no_of_traveler,class_type,no_of_child,nm_traveler_list,no_of_senior} = this.formData
        if(class_type!=3)
        {
          if(no_of_traveler>val)
            this.formData.no_of_child = Number(no_of_traveler) - Number(val) - Number(no_of_senior)
          else   this.formData.no_of_child =0
        }else{
          let travel_no = Number(val)+no_of_child +no_of_senior
          this.formData.no_of_traveler = travel_no
          if(nm_traveler_list.length<travel_no)
            for (var i= nm_traveler_list.length;i<travel_no;i++){
              let obj = JSON.parse(JSON.stringify(this.obj))
              this.formData.nm_traveler_list.push(obj)
            }
          else {
            this.formData.nm_traveler_list.splice(travel_no,nm_traveler_list.length-travel_no)
          }
        }
      }
    },
    'formData.no_of_child':{
      immediate:true,
      handler(val){
        let {class_type,nm_traveler_list,no_of_adult,no_of_traveler,no_of_senior} = this.formData
        if(class_type==3)
        {
          let travel_no = Number(val)+no_of_adult+no_of_senior
          this.formData.no_of_traveler = travel_no
          if(nm_traveler_list.length<travel_no)
            for (var i= nm_traveler_list.length;i<travel_no;i++){
              let obj = JSON.parse(JSON.stringify(this.obj))
              this.formData.nm_traveler_list.push(obj)
            }
          else {
            this.formData.nm_traveler_list.splice(travel_no,nm_traveler_list.length-travel_no)
          }

        }
      }
    },
    'formData.pcy_cmnt_dt':{
      immediate:true,
      handler(val){
        let {plan_type} = this.formData
        let {pcy_period,pcy_expry_dt,ins_end_dt} = this.form
        // if(plan_type ==2&&val)
        //   this.formData.pcy_expry_dt = dayjs(val).add(1,'year').subtract(1,'day').format('YYYY-MM-DD')
        if(pcy_period>0&&val)
          this.formData.pcy_expry_dt = dayjs(val).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD')
        if(this.isEndorsement)
        {
          if(!this.isSinglePlan)
            this.formData.pcy_expry_dt = ins_end_dt?ins_end_dt:pcy_expry_dt
        }

      }
    },
    'formData.id_type':{
      immediate: true,
      handler(val){
        if(val != 2){
          this.formData.id_type = 1
        }
      }
    },
    // 'formData.plan_type':{
    //   immediate:true,
    //   handler(val){
    //     let {pcy_cmnt_dt} = this.formData
    //     let {pcy_period} = this.form
    //     if(val ==2&&pcy_cmnt_dt)
    //       this.formData.pcy_expry_dt = dayjs(pcy_cmnt_dt).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD')
    //   }
    // }
    'form.plan_type':{
      immediate:true,
      handler(val){
        if(val==2){
          this.formData.hldr_is_traveler_ind = 1
          let {hldr_is_traveler_ind}  = this.form||{}
          if(hldr_is_traveler_ind==1||this.formData.hldr_is_traveler_ind==1){
            this.handlerSamePolicyInfo()
          }
        }
      }
    }
  },
  methods: {
    handleDate(val){
      let oneDay = this.formData.plan_type == 4
      if(oneDay){
        this.formData.pcy_cmnt_dt = this.formData.pcy_expry_dt = val
      }else{
        if(val){
          this.formData.pcy_cmnt_dt = val[0]
          this.formData.pcy_expry_dt = val[1]
        }
        else {
          this.formData.date = []
        }
      }
    },
    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        pcy_cmnt_dt,
        benefits
      }
      this.$emit('changeCompute',params)
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    handlerSamePolicyInfo(){
      const {
        id_no, id_type, isrd_dob, isrd_fst_nm, isrd_lst_nm, isrd_title,
        id_type_pic,hldr_is_traveler_ind,id_nationality_seq
      } = this.formData||{}
      const { id, client_name, path, url } = this.formData.id_type_pic || {}
      // 避免二次觸發 form 數據更新，影響 document 組件 司機數據
      if(this.formData.nm_traveler_list.length<=0) return
      if(hldr_is_traveler_ind == 1) {
        Object.assign(this.formData.nm_traveler_list[0], {
          rel: 1,
          dob: isrd_dob,
          fst_nm: isrd_fst_nm,
          id_no: id_no,
          id_type: id_type,
          lst_nm: isrd_lst_nm,
          title: isrd_title,
          id_type_pic_path_id: id,
          id_type_pic_path: path,
          id_type_pic_url: url,
          client_name: client_name,
          id_nationality_seq
        })
      }
    },
    getConfirmChangeResult(result) {
      const params = this.formResult
      if(result) {
        params.upd_def_addr = 1 // 更新用戶資料
      }
      this.$emit('getFormData', params, this.otherData)
    },
    handlerTravelStatus(status){
      this.policyOneTravel = status
    },
    async submitForm(otherData = {}) {
      await this.$refs['form'].validate((valid, rules)=> {
        if(valid) {
          this.otherData = otherData
          // debugger
          if(!this.isEasyGo)
          {
            Object.keys(this.subForm).some(key => {
              this.subForm[key] = false
              this.$refs[key].submitForm(key)
            })
            if(Object.values(this.subForm).some(item => item === false)) {
              return
            }
          }
          let {benefits=[]} = this.formData||{}
          const uniqueArray = benefits.filter((value, index, self) => {
            return self.indexOf(value) === index
          })
          let params = this.formData
          if(this.isAnual&&this.isIndividual)
          {
            // delete params.no_of_adult
            // delete params.no_of_child
          }
          const result = {
            ...params,
            benefits:uniqueArray
          }
          this.$emit('getFormData', result, otherData)
        }   else {
          this.scrollToValidDom(rules)
        }
      })
    },
    getSubFormData(formName, data) {
      this.subForm[formName] = true
      Object.assign(this.formData, data)
    },
    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      if(!this.isEasyGo){
        Object.keys(this.subForm).some(key => {
          this.subForm[key] = false
          this.$refs[key].submitFormNoVaild(key)
        })
      }
      let {benefits=[]} = this.formData||{}
      const uniqueArray = benefits.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      let params = this.formData
      if(this.isAnual&&this.isIndividual)
      {
        delete params.no_of_adult
        delete params.no_of_child
      }
      const result = {
        ...params,
        benefits:uniqueArray
      }
      this.$emit('getFormData', result, otherData)

    },
    getAddressForm(form, data) {
      // debugger
      this.subForm[form] = true
      if(form == 'address-form') {
        this.formData = Object.assign(this.formData, data)
      }
      else {
        this.handler().handlerAddressResult(data)
      }
    },

    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type, } = otherData
      const { id, path,name ,url,client_name} = data
      if(type == 'traveler_id_type_pic') {
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_path_id', id)
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_path', name)
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_url', url)
        this.$set(this.formData.nm_traveler_list[index], 'client_name', client_name)
      }
      else {
        if(type !== 'other') {
          this.$set(this.formData, idKey, id)
          this.$set(this.formData, nameKey, path)
          this.$set(this.formData, target, data)
          this.$refs['form'].validateField(idKey)
        }
        else {
          if(index === '') {
            this.formData.other_file.push(data)
          }
          else {
            this.$set(this.formData.other_file, index, data)
          }
        }
      }
    },
    handlerDeleteFile({otherData}) {
      const { type, index,target,idKey,nameKey } = otherData
      if(type === 'traveler_id_type_pic') {
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_path_id', '')
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_path', '')
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_url', '')
        this.$set(this.formData.nm_traveler_list[index], 'client_name', '')
      }else{
        this.$set(this.formData, idKey, '')
        this.$set(this.formData, nameKey, '')
        this.$set(this.formData, target, {})
      }
    },
    handler() {
      return {
        handlerAddress: (data) => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const obj = {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          }
          const params = {}
          Object.keys(this.addressForm).some(key => {
            params[key] = data[key]
          })
          this.formDataLock += 1
          this.addressForm = JSON.parse(JSON.stringify(obj))
        },
        handlerAddressResult: data => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const params = {
            cor_addr_room: addr_room,
            cor_addr_floor: addr_floor,
            cor_addr_block: addr_block,
            cor_addr_building: addr_building,
            cor_addr_street: addr_street,
            cor_addr_district: addr_district,
            cor_addr_area: addr_area,
            cor_addr_region: addr_region
          }
          Object.assign(this.formData, params)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-form {
  .title {
    font-size: 20px;
    color: #616266;
    font-weight: 500;
  }
  .travel-card{
    border: 1px solid #D1D5DA;
    border-radius: 5px;
    padding: 20px;
    margin:0 0 20px 0;
    .travel-title{
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
    }
  }

  .travel-group{
    ::v-deep .v-radio-group{
      .el-radio-group{
        display: flex;
        flex-direction: column;
        .el-radio{
          margin-top: 10px;
        }
      }
    }
  }
  .travel-box{
    .flex{
      flex-wrap: wrap;
    }
  }
.el-date-editor--daterange{
  width: 100%;
}
}
.flex-senior{
  margin-bottom: 16px;
  flex-wrap: wrap;
  /deep/.width-100{
    width: 80px;
    margin: 0px 2px 4px 2px !important;
  }
}
</style>
